import React from "react";
import { motion } from "framer-motion";
import FlameImg from "../../assets/optimized/flames-2.webp";
import Medieval from "../../assets/optimized/temple.webp";
import MedievalSmall from "../../assets/optimized/temple-sm.webp";

const features = [
  {
    category: "The Living Heritage",
    title: "Urbanism Redefined",
    description: "Centuries of devotion etched into stone and timber. Discover the living anthropology of the country's hidden courtyards.",
    image: Medieval, 
  },
  {
    category: "The Living Heritage",
    title: "Ancient Rituals",
    description: "Life breathes through butter-lamp vigils and timeless devotion. Beyond the views lie stories etched in light.",
    image: FlameImg, // Matches the Ritual Flames
  }
];

const LifestyleFeatures = () => {
  return (
    <section className="relative w-[100vw] left-[50%] right-[50%] -ml-[50vw] -mr-[50vw] py-16 md:py-20 bg-[#FCFCFC] overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        
        {/* Header Section - Clean & Minimal */}
        <div className="mb-12 md:mb-16 max-w-xl">
          <h2 className="text-[#C99D89] uppercase tracking-[0.4em] text-[8px] font-bold mb-3 popp">
            Identity Series
          </h2>
          <h3 className="text-3xl md:text-4xl font-serif text-[#575C3E] leading-[1.2] italic font-light">
            The nuances of <br/> heritage decoded.
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
          
          {/* Feature 1: The Temple (Wider for Detail) */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="md:col-span-7 flex flex-col group"
          >
            {/* Wider aspect ratio (3/2) allows the temple architecture to breathe */}
            <div className="overflow-hidden rounded-[30px] aspect-[3/2] mb-6 shadow-lg shadow-[#575C3E]/5 bg-[#f0f0f0]">
              <img 
                src={features[0].image} 
                /* Same 3:2 box at every width, so the browser can pick a size.
                   sizes: full width minus padding on phones, 7/12 of the grid from md */
                srcSet={`${MedievalSmall} 764w, ${features[0].image} 1236w`}
                sizes="(max-width: 767px) calc(100vw - 48px), 617px"
                /* object-center ensures the detailed woodwork is the focal point */
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-[3000ms]"
                alt={features[0].title}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="max-w-md">
              <h4 className="text-[#C99D89] uppercase tracking-[0.3em] text-[8px] font-bold mb-2 popp">{features[0].category}</h4>
              <h3 className="text-2xl font-serif text-[#575C3E] mb-2 italic">{features[0].title}</h3>
              <p className="text-[#575C3E]/60 font-light text-sm leading-relaxed mb-4 popp">{features[0].description}</p>
              <button className="text-[9px] uppercase tracking-widest font-bold text-[#575C3E]/40 border-b border-[#575C3E]/10 pb-1 popp hover:text-[#C99D89] hover:border-[#C99D89]">Explore →</button>
            </div>
          </motion.div>

          {/* Feature 2: The Flames (Smaller & Secondary) */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="md:col-span-5 flex flex-col group"
          >
            {/* Aspect 1/1 (Square) or 4/5 makes the flames feel less "in your face" */}
            <div className="overflow-hidden rounded-[30px] aspect-square md:max-h-[400px] mb-6 shadow-lg shadow-[#575C3E]/5 bg-[#f0f0f0]">
              <img 
                src={features[1].image} 
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[3000ms]"
                alt={features[1].title}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="">
              <h4 className="text-[#C99D89] uppercase tracking-[0.3em] text-[8px] font-bold mb-2 popp">{features[1].category}</h4>
              <h3 className="text-2xl font-serif text-[#575C3E] mb-2 italic">{features[1].title}</h3>
              <p className="text-[#575C3E]/60 font-light text-sm leading-relaxed mb-4 popp">{features[1].description}</p>
              <button className="text-[9px] uppercase tracking-widest font-bold text-[#C99D89]/40 border-b border-[#C99D89]/10 pb-1 popp hover:text-[#575C3E] hover:border-[#575C3E]">Discover →</button>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default LifestyleFeatures;